export const enum AnalyticsOnboardingModalStep {
  welcomeToT2 = 'welcome_to_t2',
}
